var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-office-filter", {
        ref: "officefilter",
        attrs: {
          objectsFetched: _vm.objectsFetched,
          objects: _vm.filteredObjects,
          multiSelectFilters: _vm.multiSelectFilters,
          apiKey: this.apiKey,
        },
        on: {
          setMultiSelectFilter: _vm.handleSelectedFilters,
          setSelectedPlacesLength: _vm.handleSelectedPlaces,
          setSelectedTypesOfBuildingsLength: _vm.handleSelectedTypesOfBuildings,
          setMinSize: _vm.handleMinSize,
          setMaxSize: _vm.handleMaxSize,
          setSortingOption: _vm.handleSortingOption,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-object-listing o-width-limiter--full",
          staticStyle: { display: "block" },
        },
        [
          _vm.isDesktop
            ? _c(
                "div",
                { staticClass: "selected-filters" },
                _vm._l(_vm.processedFilters, function (filter, index) {
                  return _c("span", { key: index, staticClass: "badge" }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(filter) + "\n\t\t\t\t"),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.removeBadge(index)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "c-icon c-icon--xss",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("svg", [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-close" },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-office-filter__sorting-container",
              class: {
                "c-office-filter__sorting-container-mobile": !_vm.isDesktop,
              },
            },
            [
              _c("div", { staticClass: "c-office-filter__container" }, [
                _c("div", { staticClass: "c-office-filter__left-item" }, [
                  _c("section", { staticClass: "c-office-filter__hits" }, [
                    _c("h3", { staticClass: "c-office-filter__hits-heading" }, [
                      _c(
                        "span",
                        { staticClass: "c-office-filter__hits-number" },
                        [_vm._v(_vm._s(_vm.filteredObjects.length))]
                      ),
                      _vm._v(" Lokaler"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-office-filter__right-item" }, [
                  _c("span", [_vm._v("Sortera på:")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "c-office-filter__sorting-select",
                      attrs: { id: "sorting-select" },
                      on: {
                        click: function ($event) {
                          _vm.showSortingOptions = !_vm.showSortingOptions
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.activeSorting.display) +
                          "\n\t\t\t\t\t\t"
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("svg", [
                            _c("use", {
                              attrs: { "xlink:href": `#icon-select-arrow` },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showSortingOptions
                    ? _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.handleClickOutside,
                              expression: "handleClickOutside",
                            },
                          ],
                          staticClass:
                            "c-office-filter__sorting-options-dropdown",
                        },
                        _vm._l(_vm.sortOptions, function (option, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass: "c-office-filter__sorting-option",
                              class: {
                                "c-office-filter__sorting-option--active":
                                  option === _vm.activeSorting,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectSortingOption(option)
                                },
                              },
                            },
                            [
                              option === _vm.activeSorting
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-icon c-icon--xs c-office-filter__check-icon",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c("svg", [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": `#icon-check`,
                                          },
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(option.display) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-object-listing__inner" },
            _vm._l(_vm.filteredObjects, function (object, index) {
              return _c(
                "div",
                { key: index, staticClass: "c-object-listing__item" },
                [
                  _c("v-object", {
                    attrs: {
                      url: object.url,
                      image: object.image,
                      title: object.title,
                      sizeFrom: object.sizeFrom,
                      sizeTo: object.sizeTo,
                      adjustedMax: object.adjustedMax,
                      city: object.city,
                      district: object.district,
                      id: `${object.district.toLowerCase()}-${object.city.toLowerCase()}`,
                      address: object.address,
                      premiseType: object.premiseType,
                      features: object.selectedFeatures,
                      overflowFeaturesCount: object.overflowFeaturesCount,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c("div", { staticClass: "c-object-listing__loading" }, [
                _vm._m(0),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-loading" }, [
      _c("span", { staticClass: "t-visually-hidden" }, [_vm._v("Laddar...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }